import React, { Fragment, useEffect, useState } from 'react';
import { faFacebookMessenger, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone, faPlus, faSms, faTicketAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row } from 'reactstrap';
import ConnectButton from './connectButton';
import WebRTC from '../Connections/WebRTC';
import { API_Web_RTC } from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
function ConnectOptions({ integrations, name, inetrgationName, propertyId }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const [webRTCIntegration, setWebRTCIntegration] = useState();
    //DialPad 
    const [showDialPad, setShowDialPad] = useState(false);

    // Dial Pad Toggle

    const dialPadToggle = () => {
        setShowDialPad(!showDialPad);
    }

    useEffect(() => {
        if (integrations.filter(f => f.channel === 'WebRTC' && f.properties.includes(propertyId) && f.disabled === false).length > 0) {
            AxiosAPI({
                method: 'get',
                url: `${API_Web_RTC}/${integrations.filter(f => f.channel === 'WebRTC' && f.properties.includes(propertyId) && f.disabled === false)[0].id}?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    if (res.data.webRTCIntegration !== undefined) {
                        setWebRTCIntegration(res.data.webRTCIntegration);
                    }

                    //     mymaPhone = new JsSIP.UA({
                    //         sockets: [new JsSIP.WebSocketInterface("wss://core1-atl.ucsandbox.net:9002")],
                    //         uri: "sip:1000wp@hotelmyma.nlv.uc",
                    //         password: "41QWACX3p2TNHrnk",
                    //     });

                    //     mymaPhone.on("connected", function (e) {
                    //         console.log('MymaPhone is Connected');
                    //         setIsMymaPhoneValid(true);
                    //     });

                    //     mymaPhone.on("disconnected", function (e) {
                    //         console.log(e, "Disconnected");
                    //     });

                    //     mymaPhone.on("registered", function (e) {
                    //         console.log(e, "rigstered");
                    //     });

                    //     mymaPhone.start();

                    //     mymaPhone.on("newRTCSession", function (data) {
                    //         var session = data.session;
                    //         console.log(session);

                    //         if (session.direction === "incoming") {
                    //             // incoming call here
                    //             session.on("accepted", function () {
                    //                 // the call has answered
                    //                 console.log("Call Accepted");
                    //             });
                    //             session.on("confirmed", function () {
                    //                 // this handler will be called for incoming calls too
                    //                 console.log("Call confirmed");
                    //             });
                    //             session.on("ended", function () {
                    //                 // the call has ended
                    //                 console.log("Call ended");
                    //             });
                    //             session.on("failed", function () {
                    //                 // unable to establish the call
                    //                 console.log("Call failed");
                    //             });
                    //             session.on("addstream", function (e) {
                    //                 // set remote audio stream (to listen to remote audio)
                    //                 // remoteAudio is <audio> element on page
                    //                 // remoteAudio.src = window.URL.createObjectURL(e.stream);
                    //                 // remoteAudio.play();
                    //             });

                    //             // Answer call
                    //             session.answer(callOptions);

                    //             // Reject call (or hang up it)
                    //             // session.terminate();
                    //         } else {
                    //             session.on("confirmed", function (e) {
                    //                 setIsOnCall(true);
                    //             });

                    //             session.on("accepted", function (e) {
                    //                 setIsOnCall(true);
                    //             });

                    //             session.on("ended", function (e) {
                    //                 //the call has ended
                    //                 setIsOnCall(false);
                    //             });

                    //             session.on("failed", function (e) {
                    //                 setIsOnCall(false);
                    //                 // unable to establish the call
                    //             });
                    //         }
                    //         //  session.terminate();
                    //     });


                    // }
                });
        }
    }, [propertyId]);

    return (
        <Fragment>
            {integrations !== undefined && integrations.length > 0 &&
                <Fragment>
                    <div style={{ position: 'absolute', bottom: '20px', right: '40px' }}>

                        <ConnectButton handleEvent={dialPadToggle} disabled={integrations.filter(f => f.channel === 'WebRTC' && f.properties.includes(propertyId) && f.disabled === false).length === 0 ? true : false}
                            iconName={faPhone} name={"Call"}
                            inetrgationName={'WebRTC'} />

                        <ConnectButton handleEvent={() => { }} disabled={integrations.filter(f => (f.channel === 'Phone' || f.channel === 'WebRTC' && f.properties.includes(propertyId)) && f.disabled === false).length === 0 ? true : false}
                            iconName={faSms} name={"SMS"}
                            inetrgationName={'FacebookDirectLine'}></ConnectButton>

                        <ConnectButton handleEvent={() => { }} disabled={integrations.filter(f => f.channel === 'WhatsApp' && f.disabled === false).length === 0 ? true : false}
                            iconName={faWhatsapp} name={"WhatsApp"}
                            inetrgationName={'WhatsApp'}></ConnectButton>

                        <ConnectButton handleEvent={() => { }} disabled={integrations.filter(f => f.channel === 'FacebookDirectLine' && f.disabled === false).length === 0 ? true : false}
                            iconName={faFacebookMessenger} name={"Messenger"}
                            inetrgationName='FacebookDirectLine'></ConnectButton>


                        <ConnectButton handleEvent={() => { }} disabled={false} iconName={faTicketAlt} name={"Ticket"}
                            inetrgationName={'Ticket'}></ConnectButton>
                    </div>
                </Fragment>}
        </Fragment >
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default
    connect(mapStateToProps, {
    })(ConnectOptions);
